export const hasFileModuleActive = (route) => {
  const hasFileModuleActive = route?.query?.['has-file-module-active'];
  if (undefined === hasFileModuleActive) {
    return true;
  }

  if (
    '0' === hasFileModuleActive || 'false' === hasFileModuleActive
    || 0 === hasFileModuleActive || false === hasFileModuleActive
  ) {
    return false;
  }

  return true;
};

export const goBackToLastPageIfPagesOverflow = (
  {
    $route,
    $router,
    paginationData: {
      page,
      show,
      total,
    },
    items = {},
  },
) => {
  if (page === 1) {
    return false;
  }

  if (total <= 0) {
    return false;
  }

  if (Object.values(items).length) {
    return false;
  }

  const lastPage = Math.ceil(total / show);

  $router.replace({
    query: {
      ...$route.query || {},
      p: lastPage,
    },
  });

  return true;
};
